import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import {
  MerchantNotification,
  MerchantNotificationsService,
} from '@services/merchant-notifications/merchant-notifications.service';

@Component({
  selector: 'app-dashboard-notifications-banner',
  templateUrl: './dashboard-notifications-banner.component.html',
  styleUrls: ['./dashboard-notifications-banner.component.scss'],
})
export class DashboardNotificationsBannerComponent implements OnInit, OnDestroy {
  notifications: MerchantNotification[] = [];

  private readonly destroyed = new Subject<void>();

  constructor(
    readonly merchantNotifications: MerchantNotificationsService,
    private readonly router: Router,
  ) {}

  ngOnInit(): void {
    this.merchantNotifications.notifications$
      .pipe(takeUntil(this.destroyed))
      .subscribe((rows) => {
        this.notifications = rows;
      });
  }

  ngOnDestroy(): void {
    this.destroyed.next();
    this.destroyed.complete();
  }

  onNotificationClick(notification: MerchantNotification): void {
    void this.merchantNotifications.markRead([String(notification.notification_id)]).subscribe(() => {
      if (notification.link_path) {
        void this.router.navigateByUrl(notification.link_path);
      }
    });
  }
}
